import React, { PropsWithChildren } from 'react';

import Footer from '../Footer';

import { Container, InnerContainer, Center } from './styles';
import { useTheme } from '../../../hooks/theme';

const Content: React.FC<PropsWithChildren> = ({ children }) => {
  const { theme } = useTheme();

  return (
    <>
      <Container 
        themeType={theme}
        id="main-scroll" 
        style={theme === 'dark' ? {
        borderRadius: '32px 0 0 0',
      } : { borderRadius: '0' }}>
        <InnerContainer>
          <Center id="content-center">
            {children}
          </Center>
        </InnerContainer>

        <Footer />
      </Container>
    </>
  );
}

export default Content;